module.exports = __webpack_public_path__ + "static/media/vault.b6f51c88.svg";